import mixins from 'vue-typed-mixins';

import PlbscfTable from '@/components/plbscfTable/PlbscfTable.vue';

import CF計算書Mixin from '@/entries/user/mixins/CF計算書Mixin';
import RoutesMixin from '@/entries/user/mixins/RoutesMixin';
import 業績予測三表Mixin from '@/entries/user/mixins/業績予測三表Mixin';

import { PlbscfTypeList } from '@/classes/service/AbstractPlbscfService';
import 業績予測Service from '@/classes/service/モニタリング/業績予測Service';

export default mixins(RoutesMixin, 業績予測三表Mixin, CF計算書Mixin).extend({
  name: 'C業績予測CF計算書',

  components: {
    PlbscfTable,
  },

  computed: {
    plbscfTypeLists(): PlbscfTypeList[] {
      return this.計画Plbscf.types.map((t) => ({
        ...t,
        header: this.header,
        list: 業績予測Service.getVisibleCfListBy基準値(t.list, this.vモニタリング業績予測基準値),
      }));
    },
  },

  created(): void {
    this.isCF計算書 = true;
  },

  methods: {
    recalculate(): void {
      this.recalculateByTypeLists(this.plbscfTypeLists);
    },
  },
});
